export default {
  title: '站内搜索',
  placeholder: '请输入搜索关键词...',
  loading: '正在搜索...',
  noResults: '没有找到相关内容',
  button: '搜索'
}; 